import { API_STATES,MOMENT_FORMAT_DATE } from '@/helpers'
import moment from 'moment'
const state = {
  taskCardDataGetState : API_STATES.NOT_REQUESTED,
  taskCardDataGetError : null,
  tasks                : [],
  taskCardFilter       : {
    showDescription : true,
    userFilter      : [''],
    date            : moment().format(MOMENT_FORMAT_DATE)
  },

  sendEmailState     : API_STATES.NOT_REQUESTED,
  sendEmailError     : null,
  showSuccessMessage : ''
}

export default state